import { render, staticRenderFns } from "./AppsNavigation.vue?vue&type=template&id=9f225ab6&scoped=true&"
import script from "./AppsNavigation.vue?vue&type=script&lang=js&"
export * from "./AppsNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AppsNavigation.vue?vue&type=style&index=0&id=9f225ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f225ab6",
  null
  
)

export default component.exports